import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import StuStudyMapArea from "@/pages/comp/plan/study/study_map/common/stu_map/list";
import TitleMapListArea from "@/pages/comp/plan/study/study_map/common/title_map/list";
import StudyMapHistoryArea from "@/pages/comp/plan/study/study_map/common/history/list";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";

function StudyMapMainPage() {
  const show_tab_arr = [
    { text: "학생별맵핑", value: "stu_map" },
    { text: "교재별맵핑", value: "title_map" },
    { text: "이력", value: "history" },
  ];
  const [show_tab, set_show_tab] = useState("stu_map");

  return (
    <CompLayout isConTitle={false}>
      <div className="text-right">
        <div style={{ display: "inline-block", width: "250px" }}>
          <SelectBoxBar
            valueTextArr={show_tab_arr}
            value={show_tab}
            name="show_tab"
            on_change={(inData: any) => {
              set_show_tab(inData.value);
            }}
            is_same_value_empty={false}
          ></SelectBoxBar>
        </div>
      </div>
      {show_tab == "stu_map" &&
        <StuStudyMapArea></StuStudyMapArea>
      }
      {show_tab == "title_map" &&
        <TitleMapListArea></TitleMapListArea>
      }
      {show_tab == "history" &&
        <StudyMapHistoryArea></StudyMapHistoryArea>
      }
    </CompLayout>
  );
}

export default StudyMapMainPage;